/**
 * Created by christiancueni on 07/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */

import { SignupActionTypes } from '../actions/signup';
import { SignupUser, SignupFormErrors } from '../models';
import { CustomAction } from '../actions/CustomAction';
import { signup, signupSuccess } from '../actions/signup';


export interface SignupState {
    loading: boolean;
    user: SignupUser;
    error: Object;
    formErrors: SignupFormErrors;
}

export const initialSignupState: SignupState = {
    loading: false,
    user: {
        schoolName: '',
        firstName: '',
        lastName: '',
        password: '',
        email: '',
        language: ''
    },
    error: null,
    formErrors: {
        schoolName: '',
        firstName: '',
        lastName: '',
        password: '',
        email: '',
    }
};

export function reducer(state = initialSignupState, action: CustomAction): SignupState {
    switch (action.type) {
        case signup.type:
            return Object.assign({}, state, {
                loading: true,
                user: action.payload
            });

        case signupSuccess.type:
            return Object.assign({}, state, {
                loading: false,
                user: initialSignupState.user,
                error: null,
                formErrors: {}
            });

        case SignupActionTypes.SIGNUP_FAILURE:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            });

        case SignupActionTypes.SIGNUP_OPENID_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                user: initialSignupState.user,
                error: null,
                formErrors: {}
            });

        case SignupActionTypes.SIGNUP_OPENID_FAILURE:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload,
                showSuccess: false
            });

        case SignupActionTypes.SIGNUP_UPDATE_FORM_ERROR:
            return Object.assign({}, state, {
                formErrors: action.payload
            });

        case SignupActionTypes.SIGNUP_CLEAR_FORM_ERROR:

            let newFormErrors = Object.assign({}, state.formErrors);

            if (action.payload in newFormErrors) {
                newFormErrors[action.payload] = '';
            }

            return Object.assign({}, state, {
                formErrors: newFormErrors
            });

        default: {
            return state;
        }
    }
}

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */
export function isLoading(state: SignupState) {
    return state.loading;
}

export function getUser(state: SignupState) {
    return state.user;
}

export function getError(state: SignupState) {
    return state.error;
}

export function getFormErrors(state: SignupState) {
    return state.formErrors;
}

